import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";
import contentApi from "../../services/contentApi";
import { canManageContent } from "./contentAccess";

const validToken = (value) => Boolean(value && value !== "undefined");

const ContentGuard = ({ children }) => {
  const [cookies, , removeCookie] = useCookies(["mytoken"]);
  const location = useLocation();
  const token = cookies.mytoken;
  const [access, setAccess] = useState({
    status: validToken(token) ? "loading" : "signed-out",
    profile: null,
  });

  useEffect(() => {
    let current = true;
    if (!validToken(token)) {
      setAccess({ status: "signed-out", profile: null });
      return undefined;
    }
    setAccess({ status: "loading", profile: null });
    contentApi.getProfile(token).then((profile) => {
      if (!current) return;
      setAccess({ status: canManageContent(profile) ? "allowed" : "forbidden", profile });
    }).catch((error) => {
      if (!current) return;
      if (error?.status === 401) removeCookie("mytoken", { path: "/" });
      setAccess({ status: error?.status === 401 ? "signed-out" : "forbidden", profile: null });
    });
    return () => { current = false; };
  }, [removeCookie, token]);

  if (access.status === "signed-out") {
    return <Navigate replace to="/content-login" state={{ from: `${location.pathname}${location.search}` }} />;
  }
  if (access.status === "forbidden") return <Navigate replace to="/" />;
  if (access.status !== "allowed") return <main className="travel-admin-gate" role="status"><span className="travel-admin-gate__spinner" aria-hidden="true" /><p>Checking content access...</p></main>;
  return React.cloneElement(children, { contentUser: access.profile, authToken: token });
};

export default ContentGuard;
